import { giphyDarkGrey } from '@giphy/colors'
import styled from 'styled-components'
import { ControlSize } from 'types'
import { DropdownButton as DropdownButtonComponent, IconButton } from 'ui'
import { heightFromControlSize } from 'utils'

export const DropdownButton = styled(DropdownButtonComponent)`
    padding-right: 0;
`

export const Button = styled(IconButton)`
    flex-shrink: 0;

    > svg {
        background: ${giphyDarkGrey};
        border-radius: 50%;
        box-sizing: content-box;
        padding: 6px;
        overflow: visible;
    }
`

export const Label = styled.div`
    align-items: center;
    display: flex;
    width: 100%;
`

export const Text = styled.div<{ $size: ControlSize }>`
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    height: ${({ $size }) => heightFromControlSize($size)}px;
    min-width: 0;
    padding: 0 0.2em 0 0.8em;
    width: 100%;

    > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &:active {
        opacity: 0.8;
    }
`
